var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-inner-loading',{staticClass:"__C_Loading",attrs:{"showing":_vm.loading}},[_c('q-spinner',{attrs:{"size":"50px","color":"primary","thickness":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }